namespace TabAurous.SalesOrder {
    export interface SalesOrderRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        PartyId?: number;
        LedgerName?: string;
        PartyCode?: string;
        GstVat?: string;
        Pan?: string;
        Email?: string;
        Address1?: string;
        Country?: string;
        State?: string;
        City?: string;
        TermsId?: number;
        Status?: string;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        CCNetAmount?: number;
        CCTaxAmount?: number;
        CCGrossAmount?: number;
        CCRoundOff?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        Username?: string;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        ItemDetails?: SalesOrderItemsRow[];
        ProductItemImage?: string;
    }

    export namespace SalesOrderRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'SalesOrder.SalesOrder';
        export const deletePermission = 'Sales:Order:Delete';
        export const insertPermission = 'Sales:Order:Add';
        export const readPermission = '*';
        export const updatePermission = 'Sales:Order:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            PartyCode = "PartyCode",
            GstVat = "GstVat",
            Pan = "Pan",
            Email = "Email",
            Address1 = "Address1",
            Country = "Country",
            State = "State",
            City = "City",
            TermsId = "TermsId",
            Status = "Status",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            CCNetAmount = "CCNetAmount",
            CCTaxAmount = "CCTaxAmount",
            CCGrossAmount = "CCGrossAmount",
            CCRoundOff = "CCRoundOff",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            Username = "Username",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            ItemDetails = "ItemDetails",
            ProductItemImage = "ProductItemImage"
        }
    }
}
